import { lazy } from 'react';

import { HeaderLogoWrapper } from 'ui/components/templates/Header';

import { useResize, useHeaderContent } from './hooks';
import { useRouterCurrent } from '../../hooks';
import { HeaderLogo } from './widgets/HeaderLogo';

const MenuMobileComponent = lazy(
  () => /* webpackChunkName: "container-menu-mobile" */ import('./HeaderMobile'),
);

const MenuDesktopComponent = lazy(
  () => /* webpackChunkName: "container-menu-desktop" */ import('./HeaderDesktop'),
);

const HeaderContainer = () => {
  const [isMobile] = useResize();
  const { isMainHeader = false, path } = useRouterCurrent();
  const allowedWithoutMainHeaderPaths = [
    '/recuperacao-de-senha',
    '/recuperacao-de-senha/email',
    '/recuperacao-de-senha/email/sucesso',
    '/perguntas-frequentes',
  ];
  const showHeader = allowedWithoutMainHeaderPaths.includes(path || '');

  useHeaderContent();

  if (showHeader) {
    return (
      <HeaderLogoWrapper>
        <HeaderLogo />
      </HeaderLogoWrapper>
    );
  }

  if (!isMainHeader) {
    return <></>;
  }

  return (
    <>
      {!isMobile && <MenuDesktopComponent />}

      {isMobile && <MenuMobileComponent />}
    </>
  );
};

export default HeaderContainer;
